import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

export const useImpressionLog = (onImpression?: () => void) => {
  const { ref, inView } = useInView({ triggerOnce: true, skip: !onImpression });

  useEffect(() => {
    if (inView) {
      onImpression?.();
    }
  }, [inView]);

  return ref;
};
